import React, { useState, useMemo } from 'react'
import { Row, Col, Typography, Radio, Card, Tag, Badge, Tooltip, Space, Timeline } from 'antd'
import { MedicineBoxOutlined, ClockCircleOutlined, UserOutlined, CalendarOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

// Enhanced mock data with actual event details
const MOCK_ROOMS = [
  {
    room: 'Cath Lab 1',
    status: 'Available',
    type: 'Catheterization',
    totalEvents: 5,
    leadStaff: 'Dr. David Lee',
    events: [
      {
        id: 'CL1-001',
        time: '09:15 - 10:30',
        title: 'Cardiac Catheterization',
        patient: 'Michael Adams',
        patientId: 'PT-1523',
        status: 'Completed'
      },
      {
        id: 'CL1-002',
        time: '10:30 - 11:00',
        title: 'Standard Cleaning',
        status: 'Completed',
        isService: true
      },
      {
        id: 'CL1-003',
        time: '11:30 - 13:45',
        title: 'Coronary Angioplasty',
        patient: 'George Wilson',
        patientId: 'PT-1526',
        status: 'Completed'
      },
      {
        id: 'CL1-004',
        time: '14:15 - 16:00',
        title: 'Pacemaker Insertion',
        patient: 'Olivia Martinez',
        patientId: 'PT-1531',
        status: 'In Progress'
      },
      {
        id: 'CL1-005',
        time: '09:30 - 11:30 (Tomorrow)',
        title: 'Coronary Angiography',
        patient: 'Thomas Rodriguez',
        patientId: 'PT-1590',
        status: 'Scheduled'
      }
    ]
  },
  {
    room: 'Cath Lab 2',
    status: 'Available',
    type: 'Catheterization',
    totalEvents: 3,
    leadStaff: 'Biomedical Engineering',
    events: [
      {
        id: 'CL2-001',
        time: '08:00 - 09:00',
        title: 'Equipment Calibration',
        status: 'Completed',
        isService: true
      },
      {
        id: 'CL2-002',
        time: '10:00 - 12:30',
        title: 'Electrophysiology Study',
        patient: 'Robert Johnson',
        patientId: 'PT-1540',
        status: 'Completed'
      },
      {
        id: 'CL2-003',
        time: '13:30 - 15:30',
        title: 'Coronary Angiography',
        patient: 'Sarah Davis',
        patientId: 'PT-1548',
        status: 'Scheduled'
      }
    ]
  },
  {
    room: 'Operating Room 1',
    status: 'Available',
    type: 'General Surgery',
    totalEvents: 6,
    leadStaff: 'Dr. Sarah Johnson',
    events: [
      {
        id: 'OR1-001',
        time: '08:30 - 10:00',
        title: 'Appendectomy',
        patient: 'Kevin Thompson',
        patientId: 'PT-1542',
        status: 'Completed'
      },
      {
        id: 'OR1-002',
        time: '10:00 - 10:30',
        title: 'Terminal Cleaning',
        status: 'Completed',
        isService: true
      },
      {
        id: 'OR1-003',
        time: '10:30 - 12:15',
        title: 'Hernia Repair',
        patient: 'Laura Martinez',
        patientId: 'PT-1563',
        status: 'In Progress'
      },
      {
        id: 'OR1-004',
        time: '13:00 - 13:30',
        title: 'Pre-operative Preparation',
        patient: 'David Wilson',
        patientId: 'PT-1575',
        status: 'Scheduled'
      },
      {
        id: 'OR1-005',
        time: '13:30 - 15:30',
        title: 'Laparoscopic Appendectomy',
        patient: 'David Wilson',
        patientId: 'PT-1575',
        status: 'Scheduled'
      },
      {
        id: 'OR1-006',
        time: '08:00 - 09:30 (Tomorrow)',
        title: 'Inguinal Hernia Repair',
        patient: 'Michael Brown',
        patientId: 'PT-1570',
        status: 'Scheduled'
      }
    ]
  },
  {
    room: 'Operating Room 2',
    status: 'Available',
    type: 'General Surgery',
    totalEvents: 5,
    leadStaff: 'Dr. James Wilson',
    events: [
      {
        id: 'OR2-001',
        time: '07:45 - 11:15',
        title: 'Total Hip Replacement',
        patient: 'Robert Garcia',
        patientId: 'PT-1498',
        status: 'Completed'
      },
      {
        id: 'OR2-002',
        time: '11:15 - 12:00',
        title: 'Terminal Cleaning',
        status: 'Completed',
        isService: true
      },
      {
        id: 'OR2-003',
        time: '12:00 - 13:30',
        title: 'Knee Arthroscopy',
        patient: 'William Davis',
        patientId: 'PT-1587',
        status: 'In Progress'
      },
      {
        id: 'OR2-004',
        time: '14:00 - 15:00',
        title: 'Arthroscopy Tower Maintenance',
        status: 'Scheduled',
        isService: true
      },
      {
        id: 'OR2-005',
        time: '08:00 - 10:30 (Yesterday)',
        title: 'Arthroscopic ACL Repair',
        patient: 'Thomas Anderson',
        patientId: 'PT-1585',
        status: 'Completed'
      }
    ]
  },
  {
    room: 'Operating Room 3',
    status: 'Available',
    type: 'General Surgery',
    totalEvents: 5,
    leadStaff: 'Cleaning Team C',
    events: [
      {
        id: 'OR3-001',
        time: '08:00 - 09:30',
        title: 'Deep Cleaning',
        status: 'Completed',
        isService: true
      },
      {
        id: 'OR3-002',
        time: '09:30 - 11:45',
        title: 'Laparoscopic Cholecystectomy',
        patient: 'Jennifer Wilson',
        patientId: 'PT-1502',
        status: 'Completed'
      },
      {
        id: 'OR3-003',
        time: '12:30 - 13:00',
        title: 'Pre-operative Preparation',
        patient: 'Elizabeth Chen',
        patientId: 'PT-1603',
        status: 'Completed'
      },
      {
        id: 'OR3-004',
        time: '13:00 - 15:30',
        title: 'Thyroidectomy',
        patient: 'Elizabeth Chen',
        patientId: 'PT-1603',
        status: 'In Progress'
      },
      {
        id: 'OR3-005',
        time: '10:00 - 14:00 (Tomorrow)',
        title: 'Colectomy',
        patient: 'Anna Miller',
        patientId: 'PT-1575',
        status: 'Scheduled'
      }
    ]
  },
  {
    room: 'Operating Room 4',
    status: 'Available',
    type: 'General Surgery',
    totalEvents: 2,
    leadStaff: 'Dr. Maria Garcia',
    events: [
      {
        id: 'OR4-001',
        time: '07:00 - 14:00',
        title: 'Coronary Artery Bypass',
        patient: 'Patricia White',
        patientId: 'PT-1367',
        status: 'Completed'
      },
      {
        id: 'OR4-002',
        time: '14:00 - 15:00',
        title: 'Terminal Cleaning',
        status: 'In Progress',
        isService: true
      }
    ]
  }
]

const TimelineView = () => {
  const [displayFilter, setDisplayFilter] = useState('all')

  // Get current date in the format shown in screenshot
  const getCurrentDateString = () => {
    const today = new Date()
    return today.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    })
  }

  // Filter rooms based on selected day
  const filteredRooms = useMemo(() => {
    if (displayFilter === 'all') {
      return MOCK_ROOMS
    }

    // Filter events based on the selected day
    return MOCK_ROOMS.map((room) => {
      const filteredEvents = room.events.filter((event) => {
        if (displayFilter === 'today' && !event.time.includes('Tomorrow') && !event.time.includes('Yesterday')) {
          return true
        }
        if (displayFilter === 'tomorrow' && event.time.includes('Tomorrow')) {
          return true
        }
        if (displayFilter === 'yesterday' && event.time.includes('Yesterday')) {
          return true
        }
        return false
      })

      return {
        ...room,
        events: filteredEvents,
        totalEvents: filteredEvents.length
      }
    }).filter((room) => room.events.length > 0)
  }, [displayFilter])

  // Helper to determine room tag
  const getRoomTypeTag = (roomType) => {
    if (roomType === 'Catheterization') {
      return (
        <Tag color='purple' style={{ float: 'right' }}>
          Catheterization
        </Tag>
      )
    } else if (roomType === 'Robotic Surgery') {
      return (
        <Tag color='blue' style={{ float: 'right' }}>
          Robotic Surgery
        </Tag>
      )
    }
    return (
      <Tag color='green' style={{ float: 'right' }}>
        General Surgery
      </Tag>
    )
  }

  // Get status badge for events
  const getStatusBadge = (status) => {
    switch (status) {
      case 'Completed':
        return <Badge status='success' text={status} />
      case 'In Progress':
        return <Badge status='processing' text={status} />
      case 'Scheduled':
        return <Badge status='default' text={status} />
      default:
        return <Badge status='default' text={status} />
    }
  }

  // Render timeline events
  const renderTimelineEvents = (events) => {
    return (
      <Timeline mode='left' style={{ marginTop: '12px' }}>
        {events.map((event) => (
          <Timeline.Item
            key={event.id}
            color={event.isService ? 'orange' : event.status === 'Completed' ? 'green' : 'blue'}
            label={event.time}
          >
            <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '3px' }}>{event.title}</div>

            {event.patient && (
              <div style={{ fontSize: '12px', marginBottom: '3px' }}>
                <UserOutlined style={{ marginRight: '5px' }} />
                {event.patient} <Text type='secondary'>({event.patientId})</Text>
              </div>
            )}

            <div>{getStatusBadge(event.status)}</div>
          </Timeline.Item>
        ))}
      </Timeline>
    )
  }

  return (
    <div>
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <Title level={5} style={{ margin: 0 }}>
            Theatre Room Timeline
          </Title>
          <Text type='secondary'>{getCurrentDateString()}</Text>
        </div>
        <Radio.Group
          value={displayFilter}
          onChange={(e) => setDisplayFilter(e.target.value)}
          buttonStyle='solid'
          size='small'
        >
          <Radio.Button value='all'>All Events</Radio.Button>
          <Radio.Button value='yesterday'>Yesterday</Radio.Button>
          <Radio.Button value='today'>Today</Radio.Button>
          <Radio.Button value='tomorrow'>Tomorrow</Radio.Button>
        </Radio.Group>
      </div>

      {filteredRooms.length > 0 ? (
        <Row gutter={[16, 16]}>
          {filteredRooms.map((roomData) => (
            <Col xs={24} md={12} key={roomData.room}>
              <Card
                title={
                  <span>
                    <MedicineBoxOutlined
                      style={{ color: roomData.room.includes('Cath Lab') ? '#722ed1' : '#1890ff', marginRight: '8px' }}
                    />
                    {roomData.room} <Badge status='success' text='Available' />
                  </span>
                }
                extra={getRoomTypeTag(roomData.type)}
                style={{
                  marginBottom: '16px',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.03), 0 1px 6px -1px rgba(0,0,0,0.02), 0 2px 4px rgba(0,0,0,0.02)'
                }}
              >
                {renderTimelineEvents(roomData.events)}

                <div
                  style={{
                    borderTop: '1px solid #f0f0f0',
                    marginTop: '12px',
                    paddingTop: '12px',
                    fontSize: '12px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: 'rgba(0,0,0,0.45)'
                  }}
                >
                  <span>
                    <ClockCircleOutlined /> Total events: {roomData.totalEvents}
                  </span>
                  <Text type='secondary' style={{ fontSize: '12px' }}>
                    Lead: {roomData.leadStaff}
                  </Text>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <div
          style={{
            textAlign: 'center',
            padding: '40px',
            color: 'rgba(0,0,0,0.45)',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px'
          }}
        >
          No events found for the selected time period
        </div>
      )}
    </div>
  )
}

export default TimelineView
